import * as Factory from 'factory.ts'

import type { Components } from '@webapp/api/integrations/client'

export const FieldMappingStub =
  Factory.Sync.makeFactory<Components.Schemas.FieldMapping>({
    field_destination: 'Departments',
    field_source: 'location',
    field_type: 'native',
  })
